const FOCUS_OUTLINE_BLEED = 4;

/** @param {import('@mui/material/styles').Theme} theme */
export const getMuiTabsButtonedStyles = (theme) => ({
  minHeight: 'auto',
  overflow: 'visible',
  borderBottom: `1px solid ${theme.palette.divider}`,
  boxSizing: 'border-box',
  padding: theme.spacing(2),
  '& .MuiTabs-scroller': {
    overflow: 'visible !important',
    boxSizing: 'border-box',
    // Room for 2px outline + 2px outlineOffset on focused tabs.
    padding: FOCUS_OUTLINE_BLEED,
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .MuiTabs-flexContainer': {
    gap: theme.spacing(1),
  },
  '& .MuiTab-root': {
    minHeight: 36,
    minWidth: 'auto',
    maxWidth: 'none',
    overflow: 'visible',
    whiteSpace: 'nowrap',
    textOverflow: 'clip',
    padding: theme.spacing(1.25, 2),
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.text.secondary,
    fontWeight: 500,
    opacity: 1,
    textTransform: 'none',
    transition: theme.transitions.create(['background-color', 'color'], {
      duration: theme.transitions.duration.short,
    }),
    '& .MuiTab-iconWrapper': {
      color: 'inherit',
      marginBottom: '0 !important',
      marginRight: theme.spacing(1),
    },
    '&.Mui-selected': {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
    '&:hover:not(.Mui-selected)': {
      backgroundColor: theme.palette.action.hover,
    },
    '&.Mui-focusVisible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
});

/** @param {import('@mui/material/styles').Theme} theme */
export const getMuiTabsButtonedCompactStyles = (theme) => {
  const buttonedStyles = getMuiTabsButtonedStyles(theme);

  return {
    ...buttonedStyles,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0.5),
    '& .MuiTabs-flexContainer': {
      gap: theme.spacing(0.5),
    },
    '& .MuiTab-root': {
      ...buttonedStyles['& .MuiTab-root'],
      fontSize: theme.typography.pxToRem(12),
      minHeight: 28,
      padding: theme.spacing(0.75, 1.5),
    },
  };
};
